import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.html',
  host: {
    class: 'block',
  },
})
export class ProgressBarComponent {
  private progressValue = 0;

  @Input() type: 'linear' | 'semi' = 'linear';
  @Input() trackClasses = '';
  @Input() progressClasses = '';

  @Input()
  set progress(value: number | string | null | undefined) {
    const numericValue = Number(value ?? 0);

    this.progressValue = Number.isFinite(numericValue)
      ? Math.min(Math.max(numericValue, 0), 100)
      : 0;
  }

  get progress(): number {
    return this.progressValue;
  }


  readonly radius = 70;
  readonly circumference = Math.PI * this.radius;

  get dashOffset(): number {
    return this.circumference * (1 - this.progress / 100);
  }
}